export default "__VITE_ASSET__UqjB$6lV__"